
export const BillPayType = {


    //recharge details


    selectedRechargableAmnt2: 'selectedRechargableAmnt2',
    setMoneyTransferTotalAmount2: 'setMoneyTransferTotalAmount2',
    setMoneyTransferSurChargeAmount2: 'setMoneyTransferSurChargeAmount2',
    showCreateOrderResponse2: 'showCreateOrderResponse2',
    setOrderId2: 'setOrderId2',
    setAmount2: 'setAmount2',
    setBillPayOperator: 'setBillPayOperator',
    setSelectedBillerCategoryCode:'setSelectedBillerCategoryCode',

    setBillPayMobile: 'setBillPayMobile',
    setBillPayOptional:'setBillPayOptional',
    setRechargeTxhHistory: 'setRechargeTxhHistory',
    setTxnAmount2: 'setTxnAmount2',
    setTxnsurcharge2: 'setTxnsurcharge2',
    setTxntotalAmoun2: 'setTxntotalAmoun2',
    setMoneyTransferProgress2: 'setMoneyTransferProgress2',
    setStatusEnqResponse2: 'setStatusEnqResponse2',

    setCreateOrderRes2:'setCreateOrderRes2',
    setCreteOrderReq2:'setCreteOrderReq2',
    setStatusEnqResponse2:'setStatusEnqResponse2',
    setBillPayTxnHistory:'setBillPayTxnHistory',

    
    setFilterStartDate:'setFilterStartDate',
    setFilterEndDate:'setFilterEndDate',
   
    RESET: "RESET"
};